import { useMemo, useRef } from 'react';
import { DEFAULTS } from '../constants';
import { isOpenPostingRestoreIntentActive, readOpenPostingState } from '../utils/openPostingStateStorage';

export const useOpenPostingRestoreState = ({ isApprovedPosting, normalizedPostingId }) => {
  const shouldPersistOpenPostingState = !isApprovedPosting && !normalizedPostingId;
  const shouldRestoreFromPersistedState = shouldPersistOpenPostingState && isOpenPostingRestoreIntentActive();

  const persistedOpenPostingStateRef = useRef(
    shouldPersistOpenPostingState && shouldRestoreFromPersistedState ? readOpenPostingState() : {},
  );
  const persistedOpenPostingState = persistedOpenPostingStateRef.current;

  const hasPersistedFilterSelection = useMemo(
    () =>
      Boolean(
        String(persistedOpenPostingState?.selectedProductType ?? '').trim() ||
          String(persistedOpenPostingState?.selectedX3ProductName ?? '').trim(),
      ),
    [persistedOpenPostingState],
  );

  const persistedWarnings =
    shouldRestoreFromPersistedState && hasPersistedFilterSelection && Array.isArray(persistedOpenPostingState?.warnings)
      ? persistedOpenPostingState.warnings.filter(Boolean)
      : DEFAULTS.EMPTY_ARRAY;

  const persistedFeedSourceData =
    shouldRestoreFromPersistedState &&
    hasPersistedFilterSelection &&
    Array.isArray(persistedOpenPostingState?.feedSourceData)
      ? persistedOpenPostingState.feedSourceData
      : DEFAULTS.EMPTY_ARRAY;

  const persistedIsApplyingFilters =
    shouldRestoreFromPersistedState &&
    hasPersistedFilterSelection &&
    Boolean(persistedOpenPostingState?.isApplyingFilters);

  return {
    shouldPersistOpenPostingState,
    shouldRestoreFromPersistedState,
    persistedWarnings,
    persistedFeedSourceData,
    persistedIsApplyingFilters,
  };
};
